import { render, staticRenderFns } from "./car_statistics.vue?vue&type=template&id=9faf91ae&scoped=true&"
import script from "./car_statistics.vue?vue&type=script&lang=js&"
export * from "./car_statistics.vue?vue&type=script&lang=js&"
import style0 from "./car_statistics.vue?vue&type=style&index=0&id=9faf91ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faf91ae",
  null
  
)

export default component.exports